import * as React from 'react';
import { TextInput, TextInputProps } from '../text-input';
import { PasswordAdornmentIcon } from './PasswordAdornmentIcon';

export type PasswordInputProps = TextInputProps;

export const PasswordInput: React.FunctionComponent<PasswordInputProps> = ({ ...extendedTextInputProps }) => {
  const [isVisible, setIsVisible] = React.useState(false);
  const toggleIsVisible = () => setIsVisible((prevState) => !prevState);

  const type = isVisible ? 'text' : 'password';

  return (
    <TextInput
      {...extendedTextInputProps}
      type={type}
      endAdornment={<PasswordAdornmentIcon toggleIsVisible={toggleIsVisible} isVisible={isVisible} />}
    />
  );
};
